import {
    DECODE_TYPE,
    EVENTS,
    EVENTS_ERROR, FILE_SUFFIX,
    FLV_BUFFER_LARGE_SIZE,
    JESSIBUCA_EVENTS,
    PLAY_TYPE,
    PLAYER_STREAM_TYPE, RENDER_TYPE,
    SCALE_MODE_TYPE
} from "../constant";
import Debug from "../utils/debug";
import Events from "../utils/events";
import property from './property';
import events from './events';
import {
    canPlayAppleMpegurl,
    createWatermark, experienceTimeout,
    fpsStatus, getDefaultPlayerOptions,
    initPlayTimes, isBoolean,
    isEmpty,
    isEmptyObject, isFalse,
    isFullScreen, isIOS, isIphone,
    isMobile, isNoSleepMobile,
    isNotEmpty,
    isNotEmptyObject, isNumber, isPc,
    isRelease,
    isSafari, isSupportSharedArrayBuffer,
    isSupportSIMD, isTrue, isWebGpuSupport, isWeChat,
    now,
    onlyMseOrWcsVideo, removeMaxAndMin, supportMediaStream,
    supportMediaStreamTrack,
    supportMSE, supportMSEDecodeHevc,
    supportOffscreenV2, supportPressureObserver,
    supportWasmUseVideoRender,
    supportWCS, supportWCSDecodeHevc
} from "../utils";
import Video from "../video";
import Audio from "../audio";
import Stream from "../stream";
import Recorder from "../recorder";
import DecoderWorker from "../worker/index";
import Emitter from "../utils/emitter";
import Demux from "../demux";
import WebcodecsDecoder from "../decoder/webcodecs";
import Control from "../control";
import './style.scss'
import observer from "./observer";
import MseDecoder from "../decoder/mediaSource";
import NoSleep from "../utils/noSleep";
import HlsDecoder from "../decoder/hls";
import HlsDecoderV2 from '../decoder/hlsV2';
import WebrtcDecoder from "../decoder/webrtc";
import WebrtcForZLMDecoder from "../decoder/webrtcForZLM";
import Playback from "../playback";
import Zoom from "../zoom";
import AiLoader from "../ai";
import Contextmenu from "../contextmenu";
import SingleWatermark from "../utils/singleWatermark";
import WebrtcForSRSDecoder from "../decoder/webrtcForSRS";
import WebrtcForOthersDecoder from "../decoder/webrtcForOthers";
import AliyunRtcDecoder from "../decoder/aliyunRtc";
import PressureObserverCpu from "../utils/PressureObserverCpu";
import DynamicWatermark from "../utils/dynamicWatermark";

export default class Player extends Emitter {

    constructor(container, options = {}) {
        super()
        /**@type {import('../constant').DEFAULT_PLAYER_OPTIONS}*/
        this._opt = {};
        this.TAG_NAME = 'Player';
        this.$container = container;
        const defaultOptions = getDefaultPlayerOptions()
        //
        this._opt = Object.assign({}, defaultOptions, options)
        this.debug = new Debug(this);
        this.debug.log(this.TAG_NAME, 'init');
        // 禁用 离屏渲染。
        this._opt.forceNoOffscreen = true;

        this._canPlayAppleMpegurl = false;

        if (isSafari() || isIOS()) {
            this._canPlayAppleMpegurl = canPlayAppleMpegurl();
            this.debug.log(this.TAG_NAME, 'isIOS or isSafari and canPlayAppleMpegurl', this._canPlayAppleMpegurl);
        }

        // 移动端不支持自动关闭控制栏
        if (isMobile()) {
            this._opt.controlAutoHide = false;
        }

        //  ios video object-fill style has bug so set false
        if (isIphone()) {
            this.debug.log(this.TAG_NAME, 'isIphone and set _opt.videoRenderSupportScale false');
            this._opt.videoRenderSupportScale = false;
            // 如果是在微信环境，hls的情况下，需要设置supportHls265 为true
            if (isWeChat() &&
                isTrue(this._opt.isHls) &&
                isFalse(this._opt.supportHls265)) {
                this.debug.log(this.TAG_NAME, 'isIphone and is in wechat and is hls so set supportHls265 true');
                this._opt.supportHls265 = true;
            }
        }

        if (isFalse(this._opt.playFailedAndReplay)) {
            this.debug.log(this.TAG_NAME, '_opt.playFailedAndReplay is false and set others replay params false');
            //  todo:记得每次新增了异常事件之后，这里都需要添加。
            this._opt.webglAlignmentErrorReplay = false;
            this._opt.webglContextLostErrorReplay = false;
            this._opt.autoWasm = false;
            this._opt.mseDecodeErrorReplay = false;
            this._opt.mediaSourceTsIsMaxDiffReplay = false;
            this._opt.wcsDecodeErrorReplay = false;
            this._opt.wasmDecodeErrorReplay = false;
            this._opt.simdDecodeErrorReplay = false;
            this._opt.videoElementPlayingFailedReplay = false;
            this._opt.networkDelayTimeoutReplay = false;
            this._opt.widthOrHeightChangeReplay = false;
            this._opt.simdH264DecodeVideoWidthIsTooLargeReplay = false;
            this._opt.mediaSourceUseCanvasRenderPlayFailedReplay = false;
            this._opt.heartTimeoutReplay = false;
            this._opt.loadingTimeoutReplay = false;
        }

        // for demo
        if (!isRelease) {
            this._opt.watermarkConfig = {
                image: {
                    src: 'data:image/png;base64,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',
                    width: 75,
                    height: 24,
                }, opacity: 0.1, right: 10, top: 10
            }
        }

        if (!this._opt.forceNoOffscreen) {
            if (!supportOffscreenV2()) {
                this._opt.forceNoOffscreen = true;
                this._opt.useOffscreen = false;
            } else {
                this._opt.useOffscreen = true;
            }
        }

        //  mpeg4 only can use ffmpeg to decode
        if (this._opt.isMpeg4) {
            this.debug.log(this.TAG_NAME, 'isMpeg4 is true, so set _opt.useWasm true and others params false');
            this._opt.useWCS = false;
            this._opt.useMSE = false;
            this._opt.isNakedFlow = false;
            this._opt.useSIMD = false;
            this._opt.isFmp4 = false;
            this._opt.useWasm = true;
        }

        //  if old hls or  old webrtc
        if (this.isOldHls() ||
            this.isWebrtcH264() ||
            this.isAliyunRtc()) {
            this.debug.log(this.TAG_NAME, 'isOldHls or isWebrtcH264 or isAliyunRtc is true, so set some params false and _opt.recordType is webm');
            this._opt.useWCS = false;
            this._opt.useMSE = false;
            this._opt.isNakedFlow = false;
            this._opt.useSIMD = false;
            this._opt.isFmp4 = false;
            this._opt.useWasm = false;
            this._opt.recordType = FILE_SUFFIX.webm;
        }
        //  if naked flow
        if (this._opt.isNakedFlow) {
            this.debug.log(this.TAG_NAME, 'isNakedFlow is true, so set _opt.mseDecodeAudio false');
            this._opt.mseDecodeAudio = false;
            // this._opt.videoBufferDelay = 10 * 60 * 1000;
        }

        // 排除hls 和 webrtc(h264) 协议
        if (!this.isOldHls() &&
            !this.isWebrtcH264()) {
            if (this._opt.useWCS) {
                const isSupportWCS = supportWCS();
                const isSupportWCSHevc = supportWCSDecodeHevc();
                this._opt.useWCS = isSupportWCS;

                if (this._opt.useWCS && this._opt.isH265) {
                    this._opt.useWCS = isSupportWCSHevc;
                }

                if (!this._opt.useWCS) {
                    this.debug.warn(this.TAG_NAME, `
                    useWCS is true,
                    and supportWCS is ${isSupportWCS}, supportHevcWCS is ${isSupportWCSHevc} , _opt.isH265 is ${this._opt.isH265}
                     so set useWCS false`);
                }

                if (this._opt.useWCS) {
                    if (this._opt.useOffscreen) {
                        this._opt.wcsUseVideoRender = false;
                    } else {
                        if (this._opt.wcsUseVideoRender) {
                            this._opt.wcsUseVideoRender = supportMediaStreamTrack() && supportMediaStream();

                            if (!this._opt.wcsUseVideoRender) {
                                this.debug.warn(this.TAG_NAME, 'wcsUseVideoRender is true, but not support so set wcsUseVideoRender false');
                            }
                        }
                    }
                }
            }

            if (this._opt.useMSE) {
                const isSupportMSE = supportMSE();
                const isSupportMSEHevc = supportMSEDecodeHevc();
                this._opt.useMSE = isSupportMSE;
                if (this._opt.useMSE && this._opt.isH265) {
                    this._opt.useMSE = isSupportMSEHevc;
                }

                if (!this._opt.useMSE) {
                    this.debug.warn(this.TAG_NAME, `
                    useMSE is true,
                    and supportMSE is ${isSupportMSE}, supportHevcMSE is ${isSupportMSEHevc} , _opt.isH265 is ${this._opt.isH265}
                     so set useMSE false`);
                }
            }
        }

        if (isFalse(this._opt.useMSE)) {
            this._opt.mseDecodeAudio = false;
        }

        // 如果使用mse则强制不允许 webcodecs
        if (this._opt.useMSE) {
            if (this._opt.useWCS) {
                this.debug.warn(this.TAG_NAME, 'useMSE is true and useWCS is true then useWCS set true->false')
            }

            if (!this._opt.forceNoOffscreen) {
                this.debug.warn(this.TAG_NAME, 'useMSE is true and forceNoOffscreen is false then forceNoOffscreen set false->true')
            }

            this._opt.useWCS = false;
            this._opt.forceNoOffscreen = true;
        } else if (this._opt.useWCS) {

        }


        if (this._opt.isWebrtc) {
            if (this._opt.demuxUseWorker) {
                this.debug.warn(this.TAG_NAME, 'isWebrtc is true and demuxUseWorker is true then demuxUseWorker set true->false');
                this._opt.demuxUseWorker = false;
            }
        }

        if (this._opt.isHls) {
            if (this._opt.demuxUseWorker) {
                this.debug.warn(this.TAG_NAME, 'isHls is true and demuxUseWorker is true then demuxUseWorker set true->false');
                this._opt.demuxUseWorker = false;
            }
        }

        if (this._opt.isAliyunRtc) {
            if (this._opt.demuxUseWorker) {
                this.debug.warn(this.TAG_NAME, 'isAliyunRtc is true and demuxUseWorker is true then demuxUseWorker set true->false');
                this._opt.demuxUseWorker = false;
            }
        }

        if (this.isStreamWebTransport()) {
            if (this._opt.demuxUseWorker) {
                this.debug.warn(this.TAG_NAME, 'is stream use webTransport is true and demuxUseWorker is true then demuxUseWorker set true->false');
                this._opt.demuxUseWorker = false;
            }
        }

        // if (this.isPlayback()) {
        //     if (this._opt.demuxUseWorker) {
        //         this.debug.warn(this.TAG_NAME, 'playback is true and demuxUseWorker is true then demuxUseWorker set true->false');
        //         this._opt.demuxUseWorker = false;
        //     }
        // }

        if (this._opt.useMThreading) {
            this._opt.useMThreading = isSupportSharedArrayBuffer();
            if (!this._opt.useMThreading) {
                this.debug.warn(this.TAG_NAME, 'useMThreading is true, but not support so set useMThreading false')
            }
        }

        // check simd
        if (this._opt.useSIMD || this._opt.decoder.indexOf('-simd') !== -1) {
            // iphone latest version ，check support simd ，but decode is crash screen，so kill iphone。
            const isSupportSimd = isSupportSIMD();
            const _isIphone = isIphone();
            this._opt.useSIMD = isSupportSimd && isFalse(_isIphone);

            if (!this._opt.useSIMD) {
                this.debug.warn(this.TAG_NAME, `useSIMD is true, but not support（isSupportSimd is ${isSupportSimd} ,isIphone is ${_isIphone}） so set useSIMD false`);
            }
        }

        if (this._opt.useSIMD) {
            //  wasm simd
            if (this._opt.decoder.indexOf('-simd') === -1) {
                if (this._opt.useMThreading) {
                    this._opt.decoder = this._opt.decoder.replace('decoder-pro.js', 'decoder-pro-simd-mt.js');
                } else {
                    this._opt.decoder = this._opt.decoder.replace('decoder-pro.js', 'decoder-pro-simd.js')
                }
            } else {
                if (this._opt.useMThreading) {
                    this._opt.decoder = this._opt.decoder.replace('decoder-pro-simd.js', 'decoder-pro-simd-mt.js')
                }
            }
        } else {
            // wasm
            if (this._opt.decoder.indexOf('-simd') !== -1) {
                if (this._opt.useMThreading) {
                    this._opt.decoder = this._opt.decoder.replace('decoder-pro-simd.js', 'decoder-pro-mt.js')
                } else {
                    this._opt.decoder = this._opt.decoder.replace('decoder-pro-simd.js', 'decoder-pro.js')
                }
            } else {
                if (this._opt.useMThreading) {
                    this._opt.decoder = this._opt.decoder.replace('decoder-pro.js', 'decoder-pro-mt.js')
                }
            }
        }

        // wasm simd
        if (this._opt.decoder.indexOf('-simd') !== -1) {
            if (this._opt.useMThreading) {
                this._opt.decoderAudio = this._opt.decoder.replace('decoder-pro-simd-mt.js', 'decoder-pro-audio.js')
                this._opt.decoderHard = this._opt.decoder.replace('decoder-pro-simd-mt.js', 'decoder-pro-hard.js')
            } else {
                this._opt.decoderAudio = this._opt.decoder.replace('decoder-pro-simd.js', 'decoder-pro-audio.js')
                this._opt.decoderHard = this._opt.decoder.replace('decoder-pro-simd.js', 'decoder-pro-hard.js')
            }
        } else {
            //  wasm
            if (this._opt.useMThreading) {
                this._opt.decoderAudio = this._opt.decoder.replace('decoder-pro-mt.js', 'decoder-pro-audio.js')
                this._opt.decoderHard = this._opt.decoder.replace('decoder-pro-mt.js', 'decoder-pro-hard.js')

            } else {
                this._opt.decoderAudio = this._opt.decoder.replace('decoder-pro.js', 'decoder-pro-audio.js')
                this._opt.decoderHard = this._opt.decoder.replace('decoder-pro.js', 'decoder-pro-hard.js')
            }
        }

        if (isFalse(this._opt.hasAudio)) {
            this._opt.operateBtns.audio = false
        }

        if (isFalse(this._opt.hasVideo)) {
            this._opt.operateBtns.fullscreen = false;
            this._opt.operateBtns.screenshot = false;
            this._opt.operateBtns.record = false;
            this._opt.operateBtns.ptz = false;
            this._opt.operateBtns.quality = false;
            this._opt.operateBtns.zoom = false;
        }

        //
        if (this._opt.qualityConfig && this._opt.qualityConfig.length === 0) {
            if (this._opt.operateBtns.quality) {
                this._opt.operateBtns.quality = false;
                this.debug.warn(this.TAG_NAME, '_opt.qualityConfig is empty, so set operateBtns.quality false')
            }
        }

        if (isTrue(this._opt.useWebGPU)) {
            this._opt.useWebGPU = isWebGpuSupport();
            if (isFalse(this._opt.useWebGPU)) {
                this.debug.warn(this.TAG_NAME, 'useWebGPU is true, but not support so set useWebGPU false');
            }
        }

        this._opt.hasControl = this._hasControl();
        //
        this._loading = false;
        this._playing = false;
        this._playbackPause = false;
        this._hasLoaded = false;
        this._zooming = false;
        this._destroyed = false;
        this._closed = false;

        //
        this._checkHeartTimeout = null;
        this._checkLoadingTimeout = null;
        this._checkStatsInterval = null;
        this._checkVisibleHiddenTimeout = null;

        //
        this._startBpsTime = null;
        //
        this._isPlayingBeforePageHidden = false;
        this._stats = {
            buf: 0, // 当前缓冲区时长，单位毫秒,
            netBuf: 0,// 网络延迟时长，单位毫秒，
            fps: 0, // 当前视频帧率
            maxFps: 0, // 最大视频帧率
            dfps: 0,// 当前解码器的帧率
            abps: 0, // 当前音频码率，单位bit
            vbps: 0, // 当前视频码率，单位bit
            ts: 0, // 当前视频帧pts，单位毫秒
            mseTs: 0, // 当前视频帧pts(mse)，单位毫秒
            currentPts: 0, // 最新显示时间戳，单位毫秒(最新渲染画面)
            pTs: 0,// 播放时间戳 单位 秒
            dts: 0,// 当前最新的dts
            mseVideoBufferDelayTime: 0, // mse video buffer delay time
            isDropping: false
        }

        this._allStatsData = {}

        this._faceDetectActive = false;
        this._objectDetectActive = false;
        this._occlusionDetectActive = false;
        this._imageDetectActive = false;

        // 各个步骤的时间统计
        this._times = initPlayTimes();

        //
        this._videoTimestamp = 0;
        this._audioTimestamp = 0;
        this._latestAudioTimestamp = 0;
        this._videoIframeIntervalTs = 0; // i 帧间隔时间。
        this._streamQuality = this._opt.defaultStreamQuality || '';
        // 默认取第一个值
        if (!this._streamQuality && this._opt.qualityConfig.length > 0) {
            this._streamQuality = this._opt.qualityConfig[0] || ''
        }
        this._visibility = true;
        this._lastestVisibilityChangeTimestamp = null;
        this._tempWorkerStats = null;
        this._historyFpsList = [];
        this._historyVideoDiffList = [];
        this._tempStreamList = [];
        this._tempInnerPlayBgobj = null;
        this._flvMetaData = null;
        this._flvMetaDataFps = null;


        if (isFalse(this._opt.useMSE) &&
            isFalse(this._opt.useWCS) &&
            !this.isWebrtcH264() &&
            !this.isOldHls()) {
            this._opt.useWasm = true;
        }

        if (this.isOldHls() || this.isWebrtcH264()) {
            this._opt.hasVideo = true;
            this._opt.hasAudio = true;
        }


        if (!this._opt.hasVideo) {
            this._opt.useMSE = false;
            this._opt.useWCS = false;
        }


        if (this._opt.useWasm) {
            // offscreen 模式下，不支持 video 渲染。
            if (this._opt.useOffscreen) {
                this._opt.wasmUseVideoRender = false;
            } else {
                if (this._opt.wasmUseVideoRender) {
                    this._opt.wasmUseVideoRender = supportWasmUseVideoRender() && supportMediaStreamTrack() && supportMediaStream();
                    if (!this._opt.wasmUseVideoRender) {
                        this.debug.warn(this.TAG_NAME, 'use wasm video render, but not support so set wasmUseVideoRender false');
                    }
                }
            }

            if (this._opt.useSIMD) {
                this.debug.log(this.TAG_NAME, 'use simd wasm')
            } else {
                this.debug.log(this.TAG_NAME, 'use wasm')
            }
        }


        if (this._opt.useWasm &&
            ((this._opt.useFaceDetector && window.JessibucaProFaceDetector) ||
                (this._opt.useObjectDetector && window.JessibucaProObjectDetector) ||
                (this._opt.useOcclusionDetector && window.JessibucaProOcclusionDetector) ||
                (this._opt.useImageDetector && window.JessibucaProImageDetector))) {
            this.ai = new AiLoader(this);

            if (!(this._opt.useFaceDetector && window.JessibucaProFaceDetector)) {
                this._opt.operateBtns.aiFace = false;
            }

            if (!(this._opt.useObjectDetector && window.JessibucaProObjectDetector)) {
                this._opt.operateBtns.aiObject = false;
            }

            if (!(this._opt.useOcclusionDetector && window.JessibucaProOcclusionDetector)) {
                this._opt.operateBtns.aiOcclusion = false;
            }

            if ((this._opt.useImageDetector &&
                this._opt.aiImageDetectActive &&
                window.JessibucaProImageDetector)) {
                this.imageDetectActive = true;
            }

        } else {
            this._opt.operateBtns.aiObject = false;
            this._opt.operateBtns.aiFace = false;
            this._opt.operateBtns.aiOcclusion = false;
        }

        if (this._opt.useFaceDetector) {
            if (!(this._opt.useWasm && window.JessibucaProFaceDetector)) {
                this.debug.warn(this.TAG_NAME, `use face detector, useWasm is ${this._opt.useWasm} and window.JessibucaProFaceDetector is null`);
            }
        }

        if (this._opt.useObjectDetector) {
            if (!(this._opt.useWasm && window.JessibucaProObjectDetector)) {
                this.debug.warn(this.TAG_NAME, `use object detector, useWasm is ${this._opt.useWasm} and window.JessibucaProObjectDetector is null`);
            }
        }

        if (this._opt.useOcclusionDetector) {
            if (!(this._opt.useWasm && window.JessibucaProOcclusionDetector)) {
                this.debug.warn(this.TAG_NAME, `use occlusion detector, useWasm is ${this._opt.useWasm} and window.JessibucaProOcclusionDetector is null`);
            }
        }

        if (this._opt.useImageDetector) {
            if (!(this._opt.useWasm && window.JessibucaProImageDetector)) {
                this.debug.warn(this.TAG_NAME, `use image detector, useWasm is ${this._opt.useWasm} and window.JessibucaProImageDetector is null`);
            }
        }

        // maybe useVideoRender and useCanvasRender all is true
        if (this._opt.useVideoRender) {
            if (this._opt.useWasm && !this._opt.useOffscreen) {
                this._opt.wasmUseVideoRender = supportWasmUseVideoRender() && supportMediaStreamTrack() && supportMediaStream();
                if (!this._opt.wasmUseVideoRender) {
                    this.debug.warn(this.TAG_NAME, 'use wasm video render, but not support so set wasmUseVideoRender false');
                }
            } else if (this._opt.useWCS && !this._opt.useOffscreen) {
                this._opt.wcsUseVideoRender = supportMediaStreamTrack() && supportMediaStream();
                if (!this._opt.wcsUseVideoRender) {
                    this.debug.warn(this.TAG_NAME, 'use wcs video render, but not support so set wcsUseVideoRender false');
                }
            }
        }

        if (this._opt.useCanvasRender) {
            if (this._opt.useMSE) {
                this._opt.mseUseCanvasRender = true
            }
            if (this._opt.useWasm) {
                this._opt.wasmUseVideoRender = false;
            }
            if (this._opt.useWCS) {
                this._opt.wcsUseVideoRender = false;
            }
            if (this.isOldHls() && !isSafari()) {
                this._opt.hlsUseCanvasRender = true;
            }
            if (this.isWebrtcH264()) {
                this._opt.webrtcUseCanvasRender = true;
            }
        }

        // 反推下 usexxx 为true 或者 false
        this._opt.useVideoRender = false;
        this._opt.useCanvasRender = false;
        if (this._opt.useWasm) {
            if (this._opt.wasmUseVideoRender) {
                this._opt.useVideoRender = true;
            } else {
                this._opt.useCanvasRender = true
            }
        } else if (this._opt.useWCS) {
            if (this._opt.wcsUseVideoRender) {
                this._opt.useVideoRender = true;
            } else {
                this._opt.useCanvasRender = true
            }
        } else if (this._opt.useMSE) {
            if (this._opt.mseUseCanvasRender) {
                this._opt.useCanvasRender = true;
            } else {
                this._opt.useVideoRender = true;
            }
        } else if (this.isOldHls()) {
            if (this._opt.hlsUseCanvasRender) {
                this._opt.useCanvasRender = true;
            } else {
                this._opt.useVideoRender = true;
            }
        } else if (this.isWebrtcH264()) {
            if (this._opt.webrtcUseCanvasRender) {
                this._opt.useCanvasRender = true;
            } else {
                this._opt.useVideoRender = true;
            }
        }

        property(this);

        this.events = new Events(this);

        if (this._opt.hasVideo) {
            this.video = new Video(this);
            this.recorder = new Recorder(this);
        }


        if (this.isOldHls()) {
            //  todo: hls
            this.hlsDecoder = new HlsDecoder(this);
            this.loaded = true;
        } else if (this.isWebrtcH264()) {
            if (this._opt.isWebrtcForZLM) {
                this.webrtc = new WebrtcForZLMDecoder(this);
            } else if (this._opt.isWebrtcForSRS) {
                this.webrtc = new WebrtcForSRSDecoder(this);
            } else if (this._opt.isWebrtcForOthers) {
                this.webrtc = new WebrtcForOthersDecoder(this);
            } else {
                this.webrtc = new WebrtcDecoder(this);
            }
            this.loaded = true;
        } else if (this.isAliyunRtc()) {
            this.aliyunRtcDecoder = new AliyunRtcDecoder(this);
            this.loaded = true;
        } else {
            if (this.isUseHls265()) {
                this.hlsDecoder = new HlsDecoderV2(this);
            }
            if (this.isWebrtcH265()) {
                this.webrtc = new WebrtcDecoder(this);
            }

            if (isFalse(onlyMseOrWcsVideo(this._opt))) {
                this.decoderWorker = new DecoderWorker(this);
            } else {
                this.loaded = true
            }
        }

        if (this._opt.hasAudio) {
            this.audio = new Audio(this);
        }


        this.stream = null;
        this.demux = null;
        this._lastVolume = null;
        this._isInZoom = false;
        this._playingStartTimestamp = null;

        if (this._opt.useWCS) {
            this.webcodecsDecoder = new WebcodecsDecoder(this)
            if (!this._opt.hasAudio && isFalse(this._opt.demuxUseWorker)) {
                this.loaded = true
            }
        }

        if (this._opt.useMSE) {
            this.mseDecoder = new MseDecoder(this);
            if (!this._opt.hasAudio &&
                isFalse(this._opt.demuxUseWorker)) {
                this.loaded = true
            }
        }

        //
        this.control = new Control(this);

        //  右键菜单，for pc
        if (this._opt.contextmenuBtns.length > 0 &&
            isFalse(this._opt.disableContextmenu) &&
            isPc()) {
            this.contextmenu = new Contextmenu(this);
        } else {
            if (isTrue(this._opt.disableContextmenu) &&
                this._opt.contextmenuBtns.length > 0 &&
                isPc()) {
                this.debug.warn(this.TAG_NAME, 'disableContextmenu is true, but contextmenuBtns is not empty, so Contextmenu can not be created，please check');
            }
        }

        if (this.isPlayback()) {
            this.playback = new Playback(this, this._opt.playbackConfig);
        }

        if (this._opt.operateBtns.zoom) {
            this.zoom = new Zoom(this);
        }


        if (isNoSleepMobile() &&
            isFalse(this._opt.supportLockScreenPlayAudio && isIOS())) {
            this.keepScreenOn = new NoSleep(this);
        }
        events(this);
        observer(this);

        this.singleWatermark = new SingleWatermark(this);

        if (this._opt.ghostWatermarkConfig.content || isFalse(isRelease)) {
            const config = Object.assign({}, this._opt.ghostWatermarkConfig, {
                isGhost: true,
            });
            this.ghostWatermark = new DynamicWatermark(this, config);
        }

        if (this._opt.dynamicWatermarkConfig.content || isFalse(isRelease)) {
            this.dynamicWatermark = new DynamicWatermark(this, this._opt.dynamicWatermarkConfig);
        }


        if (this._opt.watermarkConfig) {
            this.updateWatermark(this._opt.watermarkConfig)
        }

        if (supportPressureObserver()) {
            this.pressureObserverCpu = new PressureObserverCpu(this);
        }


        if (this._opt.useWCS) {
            this.debug.log(this.TAG_NAME, 'use WCS')
        }

        if (this._opt.useMSE) {
            this.debug.log(this.TAG_NAME, 'use MSE')
        }

        if (this._opt.useOffscreen) {
            this.debug.log(this.TAG_NAME, 'use offscreen')
        }

        if (this._opt.isHls) {

            if (this._opt.supportHls265) {
                this.debug.log(this.TAG_NAME, 'use hls 265');
            } else {
                this.debug.log(this.TAG_NAME, 'use hls');
            }
        }

        if (this._opt.isWebrtc) {
            if (this._opt.isWebrtcH265) {
                this.debug.log(this.TAG_NAME, 'use webrtc h265');
            } else {
                if (this._opt.isWebrtcForZLM) {
                    this.debug.log(this.TAG_NAME, 'use webrtc for ZLM');
                } else if (this._opt.isWebrtcForSRS) {
                    this.debug.log(this.TAG_NAME, 'use webrtc for SRS');
                } else if (this._opt.isWebrtcForOthers) {
                    this.debug.log(this.TAG_NAME, 'use webrtc for Others');
                } else {
                    this.debug.log(this.TAG_NAME, 'use webrtc for M7S');
                }
            }
        }

        if (this.isAliyunRtc()) {
            this.debug.log(this.TAG_NAME, 'use aliyun rtc');
        }

        if (this._opt.isFmp4) {
            this.debug.log(this.TAG_NAME, 'use fmp4');
        }

        if (this._opt.isMpeg4) {
            this.debug.log(this.TAG_NAME, 'use mpeg4');
        }

        if (this.isPlayback()) {
            this.debug.log(this.TAG_NAME, 'use playback')
        }

        if (this._opt.hasVideo) {
            if (this.width === 0) {
                this.debug.warn(this.TAG_NAME, 'container width is 0, please check the container width')
            }

            if (this.height === 0) {
                this.debug.warn(this.TAG_NAME, 'container height is 0, please check the container height')
            }
        }

        this.debug.log('Player options', JSON.stringify(this._opt));
    }

    async destroy() {
        this._destroyed = true;
        // 其他没法解耦的，通过 destroy 方式
        this.emit('destroy');
        // 接触所有绑定事件
        this.off();

        // 接触所有的event 事件
        if (this.events) {
            this.events.destroy();
            this.events = null;
        }
        this.clearCheckLoadingTimeout();
        this.clearStatsInterval();
        this.clearVisibilityHiddenTimeout();
        // worker
        if (this.decoderWorker) {
            await this.decoderWorker.destroy();
            this.decoderWorker = null;
        }
        await this._destroy();
    }

    async _destroy() {
        this._loading = false;
        this._playing = false;
        this._playbackPause = false;
        this._hasLoaded = false;
        this._lastVolume = null;
        this._zooming = false;
        this._faceDetectActive = false;
        this._objectDetectActive = false;
        this._occlusionDetectActive = false;
        this._imageDetectActive = false;
        this._times = initPlayTimes();

        // 移除水印
        if (this.singleWatermark) {
            this.singleWatermark.destroy();
            this.singleWatermark = null;
        }

        if (this.ghostWatermark) {
            this.ghostWatermark.destroy();
            this.ghostWatermark = null;
        }

        if (this.dynamicWatermark) {
            this.dynamicWatermark.destroy();
            this.dynamicWatermark = null;
        }

        //  监听cpu 压力
        if (this.pressureObserverCpu) {
            this.pressureObserverCpu.destroy();
            this.pressureObserverCpu = null;
        }

        if (this.stream) {
            this.stream.destroy();
            this.stream = null;
        }

        if (this.hlsDecoder) {
            await this.hlsDecoder.destroy();
            this.hlsDecoder = null;
        }

        if (this.mseDecoder) {
            this.mseDecoder.destroy();
            this.mseDecoder = null;
        }

        if (this.webrtc) {
            this.webrtc.destroy();
            this.webrtc = null;
        }

        if (this.aliyunRtcDecoder) {
            this.aliyunRtcDecoder.destroy();
            this.aliyunRtcDecoder = null;
        }

        if (this.video) {
            this.video.destroy();
            this.video = null;
        }

        if (this.audio) {
            this.audio.destroy();
            this.audio = null;
        }

        if (this.recorder) {
            this.recorder.destroy();
            this.recorder = null;
        }

        if (this.control) {
            this.control.destroy();
            this.control = null;
        }

        if (this.webcodecsDecoder) {
            this.webcodecsDecoder.destroy();
            this.webcodecsDecoder = null;
        }

        if (this.demux) {
            this.demux.destroy();
            this.demux = null;
        }

        if (this.playback) {
            this.playback.destroy();
            this.playback = null;
        }

        if (this.zoom) {
            this.zoom.destroy();
            this.zoom = null;
        }

        if (this.ai) {
            this.ai.destroy();
            this.ai = null;
        }

        //
        if (this.keepScreenOn) {
            this.releaseWakeLock();
            this.keepScreenOn.destroy();
            this.keepScreenOn = null;
        }
        // reset stats
        this.resetStats();
        this._audioTimestamp = 0;
        this._latestAudioTimestamp = 0;
        this._videoTimestamp = 0;
        this._streamQuality = '';
        this._visibility = true;
        this._isInZoom = false;
        this._playingStartTimestamp = null;
        this._lastestVisibilityChangeTimestamp = null;
        this._videoIframeIntervalTs = null;
        this._tempWorkerStats = null;
        this._tempStreamList = [];
        this._tempInnerPlayBgobj = {};
        this._flvMetaData = null;
        this._flvMetaDataFps = null;

        this.debug.log('play', 'destroy end');
        this._opt = getDefaultPlayerOptions();
        this.$container = null;
    }


    set fullscreen(value) {
        if (isMobile() && this._opt.useWebFullScreen) {
            this.webFullscreen = value;
        } else {
            this.emit(EVENTS.fullscreen, value);
        }
    }

    get fullscreen() {
        return isFullScreen() || this.webFullscreen;
    }

    set webFullscreen(value) {
        this.emit(EVENTS.webFullscreen, value);
        setTimeout(() => {
            this.updateOption({
                rotate: value ? 270 : 0,
            })
            this.resize();
        }, 10)
    }

    get webFullscreen() {
        return this.$container.classList.contains('jessibuca-fullscreen-web')
    }

    set loaded(value) {
        this._hasLoaded = value;
    }

    //
    get loaded() {
        return this._hasLoaded ||
            this.isOldHls() ||
            this.isWebrtcH264() ||
            (this._opt.useMSE && isFalse(this._opt.hasAudio) && isFalse(this._opt.demuxUseWorker)) ||
            (this._opt.useWCS && !this._opt.hasAudio && isFalse(this._opt.demuxUseWorker));
    }

    //
    set playing(value) {

        if (this.isClosed() && value) {
            this.debug.log(this.TAG_NAME, 'player is closed, so can not play');
            return;
        }

        if (value &&
            isTrue(this.loading)) {
            // 将loading 设置为 false
            this.loading = false;
        }

        if (this.playing !== value) {
            this._playing = value;
            this.emit(EVENTS.playing, value);
            this.emit(EVENTS.volumechange, this.volume);

            if (value) {
                this.emit(EVENTS.play);
            } else {
                this.emit(EVENTS.pause);
            }
        }

    }

    get playing() {
        return this._playing;
    }

    get volume() {
        return (this.audio && this.audio.volume) || 0;
    }

    set volume(value) {
        if (value !== this.volume) {
            if (this.audio) {
                this.audio.setVolume(value);
                this._lastVolume = this.volume;
            } else {
                this.debug.warn(this.TAG_NAME, 'set volume error, audio is null');
            }
        }
    }

    get lastVolume() {
        return this._lastVolume
    }

    set loading(value) {
        if (this.loading !== value) {
            this._loading = value;
            this.emit(EVENTS.loading, this._loading);
        }
    }

    get loading() {
        return this._loading;
    }

    set zooming(value) {
        if (this.zooming !== value) {
            if (!this.zoom) {
                this.zoom = new Zoom(this);
            }

            this._zooming = value;
            this.emit(EVENTS.zooming, this.zooming);
        }
    }

    get zooming() {
        return this._zooming;
    }

    set recording(value) {
        if (value) {
            if (this.playing && !this.recording) {
                this.recorder && this.recorder.startRecord();
                if (this.isDemuxInWorker() && this.decoderWorker) {
                    this.decoderWorker.updateWorkConfig({
                        key: 'isRecording', value: true
                    })
                }
            }
        } else {
            if (this.recording) {
                if (this.isDemuxInWorker() && this.decoderWorker) {
                    this.decoderWorker.updateWorkConfig({
                        key: 'isRecording', value: false
                    })
                }
                this.recorder && this.recorder.stopRecordAndSave().then(() => {

                }).catch((e) => {

                });
            }
        }
    }

    get recording() {
        return this.recorder ? this.recorder.isRecording : false;
    }

    set audioTimestamp(value) {
        if (value === null) {
            return;
        }
        this._audioTimestamp = value;
    }

    //
    get audioTimestamp() {
        return this._audioTimestamp;
    }

    set latestAudioTimestamp(value) {
        if (value === null) {
            return;
        }
        this._latestAudioTimestamp = value;
    }

    get latestAudioTimestamp() {
        return this._latestAudioTimestamp;
    }

    //
    get videoTimestamp() {
        return this._stats.currentPts || this._stats.ts;
    }

    set streamQuality(value) {
        if (this.streamQuality !== value) {
            this._streamQuality = value;
            this.emit(EVENTS.streamQualityChange, value);
        }
    }

    get streamQuality() {
        return this._streamQuality;
    }

    get isDebug() {
        return isTrue(this._opt.debug);
    }

    get scaleType() {
        const opt = this._opt;
        const isResize = opt.isResize;
        const isFullResize = opt.isFullResize;

        let result = SCALE_MODE_TYPE.full;

        if (isFalse(isFullResize) && isFalse(isResize)) {
            result = SCALE_MODE_TYPE.full;
        } else if (isFalse(isFullResize) && isTrue(isResize)) {
            result = SCALE_MODE_TYPE.auto
        } else if (isTrue(isFullResize) && isTrue(isResize)) {
            result = SCALE_MODE_TYPE.fullAuto
        }

        return result;
    }

    //
    set visibility(value) {
        if (this._visibility !== value) {
            this._visibility = value;
            this.emit(EVENTS.visibilityChange, value)
            this._lastestVisibilityChangeTimestamp = now();
            if (value) {
                this.clearVisibilityHiddenTimeout();
            } else {
                this.startVisibilityHiddenTimeout();
            }
        }
    }

    //
    get visibility() {
        return this._visibility;
    }

    set playbackPause(value) {
        if (this._playbackPause !== value) {
            this._playbackPause = value;
            // inner
            this.emit(EVENTS.playbackPause, value);
            // out
            this.emit(EVENTS.playbackPauseOrResume, value);
        }
    }

    get playbackPause() {
        return this.isPlayback() && this._playbackPause;
    }

    set videoIframeIntervalTs(ts) {
        this._videoIframeIntervalTs = ts;
    }

    get videoIframeIntervalTs() {
        return this._videoIframeIntervalTs
    }

    set faceDetectActive(value) {
        if (this._faceDetectActive !== value) {
            this._faceDetectActive = value;
            this.emit(EVENTS.faceDetectActive, value)
        }
    }

    get faceDetectActive() {
        return this._faceDetectActive;
    }

    set objectDetectActive(value) {
        if (this._objectDetectActive !== value) {
            this._objectDetectActive = value;
            this.emit(EVENTS.objectDetectActive, value)
        }
    }

    get objectDetectActive() {
        return this._objectDetectActive;
    }

    set occlusionDetectActive(value) {
        if (this._occlusionDetectActive !== value) {
            this._occlusionDetectActive = value;
            this.emit(EVENTS.occlusionDetectActive, value)
        }
    }

    get occlusionDetectActive() {
        return this._occlusionDetectActive;
    }

    set imageDetectActive(value) {
        if (this._imageDetectActive !== value) {
            this._imageDetectActive = value;
            // this.emit(EVENTS.imageDetectActive, value)
        }
    }

    get imageDetectActive() {
        return this._imageDetectActive;
    }


    get isUseWorkerDemuxAndDecode() {
        return this.stream && (this.stream.getStreamType() === PLAYER_STREAM_TYPE.worker);
    }

    isDestroyed() {
        return this._destroyed;
    }

    isClosed() {
        return this._closed;
    }

    isPlaying() {
        let result = false;
        if (this._opt.playType === PLAY_TYPE.player) {
            result = this.playing;
        } else if (this._opt.playType === PLAY_TYPE.playbackTF) {
            result = isFalse(this.playbackPause) && this.playing;
        }

        return result;
    }

    /**
     *
     * @param options
     */
    updateOption(options, needWorkerUpdate = false) {
        this._opt = Object.assign({}, this._opt, options)
        if (isTrue(needWorkerUpdate) && this.decoderWorker) {
            Object.keys(options).forEach((key) => {
                this.decoderWorker.updateWorkConfig({
                    key, value: options[key]
                })
            })
        }
    }

    /**
     *
     * @returns {Promise<unknown>}
     */
    init() {
        return new Promise((resolve, reject) => {


            if (!this.video) {
                if (this._opt.hasVideo) {
                    this.video = new Video(this);
                }
            }

            if (!this.audio) {
                if (this._opt.hasAudio) {
                    this.audio = new Audio(this);
                }
            }

            if (!this.stream) {
                this.stream = new Stream(this);
            }

            if (this.isOldHls()) {
                if (!this.hlsDecoder) {
                    //  todo: hls
                    this.hlsDecoder = new HlsDecoder(this);
                    this.loaded = true
                }
                resolve();
            } else if (this.isWebrtcH264()) {
                if (!this.webrtc) {
                    if (this._opt.isWebrtcForZLM) {
                        this.webrtc = new WebrtcForZLMDecoder(this);
                    } else if (this._opt.isWebrtcForSRS) {
                        this.webrtc = new WebrtcForSRSDecoder(this);
                    } else if (this._opt.isWebrtcForOthers) {
                        this.webrtc = new WebrtcForOthersDecoder(this);
                    } else {
                        this.webrtc = new WebrtcDecoder(this);
                    }
                    this.loaded = true
                }
                resolve();
            } else if (this.isAliyunRtc()) {
                if (!this.aliyunRtcDecoder) {
                    this.aliyunRtcDecoder = new AliyunRtcDecoder(this);
                    this.loaded = true;
                }
                resolve();
            } else {
                if (!this.demux) {
                    if (this._opt.hasVideo && !this.isUseWorkerDemuxAndDecode) {
                        this.demux = new Demux(this);
                    }
                }

                if (this._opt.useWCS) {
                    if (!this.webcodecsDecoder) {
                        this.webcodecsDecoder = new WebcodecsDecoder(this)
                    }
                }

                if (this._opt.useMSE) {
                    if (!this.mseDecoder) {
                        this.mseDecoder = new MseDecoder(this);
                    }
                }

                if (this.isUseHls265()) {
                    if (!this.hlsDecoder) {
                        this.hlsDecoder = new HlsDecoderV2(this);
                    }
                }

                if (this.isWebrtcH265()) {
                    if (!this.webrtc) {
                        this.webrtc = new WebrtcDecoder(this);
                    }
                }

                if (this.decoderWorker) {
                    if (this.loaded) {
                        resolve();
                    } else {
                        this.once(EVENTS.decoderWorkerInit, () => {
                            if (this.isDestroyed()) {
                                this.debug.error(this.TAG_NAME, 'init() failed and player is destroyed');
                                reject('init() failed and player is destroyed')
                            } else {
                                this.loaded = true;
                                resolve()
                            }
                        })
                    }
                } else {
                    if (!onlyMseOrWcsVideo(this._opt)) {
                        this.decoderWorker = new DecoderWorker(this);

                        this.once(EVENTS.decoderWorkerInit, () => {
                            if (this.isDestroyed()) {
                                this.debug.error(this.TAG_NAME, 'init() failed and player is destroyed');
                                reject('init() failed and player is destroyed')
                            } else {
                                this.loaded = true;
                                resolve()
                            }
                        })
                    } else {
                        resolve();
                    }
                }
            }
        })
    }


    /**
     *
     * @param url
     * @returns {Promise<unknown>}
     */
    play(url, options = {}) {
        return new Promise((resolve, reject) => {
            if (!url && !this._opt.url) {
                return reject("url is empty");
            }
            this._closed = false;
            this.loading = true;
            this.playing = false;
            this._times.playInitStart = now();
            if (!url) {
                url = this._opt.url;
            }
            this._opt.url = url;


            if (this.control && this._opt.loadingBackground) {
                this.control.initLoadingBackground();
            }

            this.init().then(() => {
                this.debug.log(this.TAG_NAME, 'play() init and next fetch stream');
                this._times.playStart = now();
                //
                if (this._opt.isNotMute) {
                    this.mute(false);
                }

                this.enableWakeLock();
                //
                this.checkLoadingTimeout();
                if (this.stream) {
                    // fetch error
                    this.stream.once(EVENTS_ERROR.fetchError, (error) => {
                        this.emitError(EVENTS_ERROR.fetchError, error);
                        //reject(error)
                    })
                    // ws
                    this.stream.once(EVENTS_ERROR.websocketError, (error) => {
                        this.emitError(EVENTS_ERROR.websocketError, error);
                        //reject(error)
                    })

                    // stream end
                    this.stream.once(EVENTS.streamEnd, () => {
                        this.emit(EVENTS.streamEnd);
                        // reject('stream end');
                    })
                    // hls
                    this.stream.once(EVENTS_ERROR.hlsError, (error) => {
                        this.emitError(EVENTS_ERROR.hlsError, error);
                        // reject(error)
                    })

                    // webrtc
                    this.stream.once(EVENTS_ERROR.webrtcError, (error) => {
                        this.emitError(EVENTS_ERROR.webrtcError, error);
                        // reject(error);
                    })

                    // success
                    this.stream.once(EVENTS.streamSuccess, () => {
                        resolve();
                        this._times.streamResponse = now();
                        this.video && this.video.play();
                        this.checkStatsInterval();
                        if (this.isPlayback() && this.playback) {
                            this.playback.startCheckStatsInterval()
                        }
                        if (!isRelease) {
                            const timeout = Number(experienceTimeout) || 1;
                            setTimeout(() => {
                                this.destroy();
                                console.error('jessibuca pro 体验结束,请刷新页面再次体验(wasm内部会暂停解码)');
                                alert('jessibuca pro 体验结束,请刷新页面再次体验，如需要购买商业授权，可以联系微信：bosswancheng');
                                window.location.reload();
                            }, timeout * 60 * 60 * 1000)
                        }
                    })

                    this.stream.fetchStream(url, options);
                } else {
                    this.debug.warn(this.TAG_NAME, `play() this.stream is null and is destroy is ${this.isDestroyed()}`);
                    reject('this.stream is null');
                }

            }).catch((e) => {
                reject(e)
            })
        })
    }


    playForControl() {
        return new Promise((resolve, reject) => {
            this.debug.log(this.TAG_NAME, `playForControl() and pauseAndNextPlayUseLastFrameShow is ${this._opt.pauseAndNextPlayUseLastFrameShow}`);
            if (this._opt.pauseAndNextPlayUseLastFrameShow) {
                if (this._tempInnerPlayBgobj &&
                    this._tempInnerPlayBgobj.loadingBackground) {
                    this.updateOption({
                        loadingBackground: this._tempInnerPlayBgobj.loadingBackground,
                        loadingBackgroundWidth: this._tempInnerPlayBgobj.loadingBackgroundWidth,
                        loadingBackgroundHeight: this._tempInnerPlayBgobj.loadingBackgroundHeight,
                    })
                }
            }

            this.play().then((res) => {
                resolve(res)
            }).catch((e) => {
                reject(e);
            })
        })
    }

    /**
     * _close() and clearView();
     */
    close() {
        return new Promise((resolve, reject) => {
            this._close().then(() => {
                this.video && this.video.clearView();
                resolve()
            }).catch((e) => {
                reject(e);
            })
        })
    }

    resumeAudioAfterPause() {
        if (this.lastVolume) {
            this.volume = this.lastVolume;
        }
    }

    /**
     *
     * @returns {Promise<unknown>}
     * @private
     */
    _close() {
        return new Promise((resolve, reject) => {

            this._closed = true;
            if (this.video) {
                this.video.resetInit();
                this.video.pause(true);
            }

            this.loading = false;
            this.recording = false;
            this.zooming = false;
            this.playing = false;
            this.clearCheckLoadingTimeout();
            this.clearStatsInterval();

            if (this.isPlayback() && this.playback) {
                this.playback.clearStatsInterval()
            }

            // release lock
            this.releaseWakeLock();
            // reset stats
            this.resetStats();
            //
            this._audioTimestamp = 0;
            this._videoTimestamp = 0;
            //
            this._times = initPlayTimes();

            const _next = () => {
                //
                if (this.stream) {
                    this.stream.destroy();
                    this.stream = null;
                }

                if (this.demux) {
                    this.demux.destroy();
                    this.demux = null;
                }

                if (this.webcodecsDecoder) {
                    this.webcodecsDecoder.destroy();
                    this.webcodecsDecoder = null;
                }
                //
                if (this.mseDecoder) {
                    this.mseDecoder.destroy();
                    this.mseDecoder = null;
                }
                //
                if (this.hlsDecoder) {
                    this.hlsDecoder.destroy();
                    this.hlsDecoder = null;
                }

                if (this.webrtc) {
                    this.webrtc.destroy();
                    this.webrtc = null;
                }

                if (this.aliyunRtcDecoder) {
                    this.aliyunRtcDecoder.destroy();
                    this.aliyunRtcDecoder = null;
                }

                if (this.audio) {
                    this.audio.destroy();
                    this.audio = null;
                }

            }

            //
            if (this.decoderWorker) {
                this.decoderWorker.destroy().then(() => {
                    this.decoderWorker = null;
                    _next();
                    setTimeout(() => {
                        resolve()
                    }, 0)
                }).catch((e) => {
                    this.debug && this.debug.error(this.TAG_NAME, 'close() decoderWorker.destroy() error', e);
                    reject();
                });
            } else {
                _next();
                //
                setTimeout(() => {
                    resolve()
                }, 0)
            }
        })
    }

    /**
     *
     * @param flag {boolean} 是否清除画面
     * @returns {Promise<unknown>}
     */
    pause(flag = false) {
        return new Promise((resolve, reject) => {
            if (flag) {
                this.close().then(() => {
                    resolve();
                }).catch((e) => {
                    reject(e);
                });
            } else {
                this._close().then(() => {
                    resolve();
                }).catch((e) => {
                    reject(e);
                });
            }
        })
    }

    /**
     * for inner use
     * @param flag
     * @returns {Promise<unknown>}
     * @private
     */
    pauseForControl() {
        return new Promise((resolve, reject) => {
            this.debug.log(this.TAG_NAME, `_pauseInner()`);
            if (this._opt.pauseAndNextPlayUseLastFrameShow && this.video) {
                const loadingBackground = this.video.screenshot('', 'png', 0.92, 'base64');
                if (loadingBackground) {
                    const videoInfo = this.getVideoInfo();
                    if (videoInfo) {
                        this.debug.log(this.TAG_NAME, `pauseForControl() and loadingBackground width is ${videoInfo.width} and height is ${videoInfo.height}`);
                        this._tempInnerPlayBgobj = {
                            loadingBackground,
                            loadingBackgroundWidth: videoInfo.width,
                            loadingBackgroundHeight: videoInfo.height,
                        }
                    } else {
                        this.debug.warn(this.TAG_NAME, `pauseForControl() and videoInfo is null`);
                    }
                } else {
                    this.debug.warn(this.TAG_NAME, `pauseForControl() and loadingBackground is null`);
                }
            }

            this.pause().then((res) => {
                resolve(res);
            }).catch((e) => {
                reject(e);
            })
        })
    }

    isAudioMute() {
        let result = true;
        if (this.audio) {
            result = this.audio.isMute;
        }
        return result;
    }

    isAudioNotMute() {
        return !this.isAudioMute()
    }

    /**
     *
     * @param flag
     */
    mute(flag) {
        this.audio && this.audio.mute(flag)
    }

    /**
     *
     */
    resize() {
        this.video && this.video.resize();
    }

    /**
     *
     * @param fileName
     * @param fileType
     */
    startRecord(fileName, fileType) {
        if (this.recording) {
            return;
        }

        this.recorder.setFileName(fileName, fileType);
        this.recording = true;
    }

    /**
     *
     */
    stopRecordAndSave(type, fileName) {
        // if (this.recording) {
        //     this.recording = false;
        // }
        return new Promise((resolve, reject) => {
            if (!this.recorder) {
                reject('recorder is null');
            }
            if (this.recording) {
                if (this._opt.useWasm && this.decoderWorker) {
                    this.decoderWorker.updateWorkConfig({
                        key: 'isRecording', value: false
                    })
                }
                this.recorder.stopRecordAndSave(type, fileName).then((blob) => {
                    resolve(blob);
                }).catch((e) => {
                    reject(e)
                })
            } else {
                reject('recorder is not recording');
            }
        })
    }

    _hasControl() {
        let result = false;

        let hasBtnShow = false;
        Object.keys(this._opt.operateBtns).forEach((key) => {
            if (this._opt.operateBtns[key] && ('' + key).indexOf('Fn') === -1) {
                hasBtnShow = true;
            }
        });

        if (this._opt.showBandwidth || hasBtnShow) {
            result = true;
        }

        if (this._opt.extendOperateBtns && this._opt.extendOperateBtns.length > 0) {
            result = true;
        }

        if (this.isPlayback() && this._opt.playbackConfig.showControl) {
            result = true;
        }

        return result;
    }

    // wasm 解码
    useWasmDecode() {
        return isFalse(this._opt.useMSE) && isFalse(this._opt.useWCS)
    }

    // wasm 或者webcodecs解码 用video 标签渲染
    canVideoTrackWritter() {
        const _opt = this._opt;
        return !this.isOldHls() && // hls 旧版不支持
            !this.isWebrtcH264() && // webrtc h264 不支持
            isFalse(_opt.useMSE) && // mse 不支持
            !this.isAliyunRtc() && // 阿里云rtc 不支持
            ((_opt.useWCS && isFalse(_opt.useOffscreen) && _opt.wcsUseVideoRender) || this.useWasmDecode());
    }

    // 心跳检查，如果渲染间隔暂停了多少时间之后，就会抛出异常
    checkHeartTimeout$2() {
        // if playing is true and playback pause is false
        if (isFalse(this.playbackPause) &&
            this.playing) {
            // check is destroyed
            if (this.isDestroyed()) {
                this.debug && this.debug.warn(this.TAG_NAME, `checkHeartTimeout$2 but player is destroyed`)
                return;
            }

            //  check again
            if (isFalse(this.isHistoryFpsListAllZero())) {
                this.debug && this.debug.warn(this.TAG_NAME, `checkHeartTimeout$2 but fps is not all zero`)
                return;
            }

            // check again
            if (this._stats.fps !== 0) {
                this.debug && this.debug.warn(this.TAG_NAME, `checkHeartTimeout$2 but fps is ${this._stats.fps}`)
                return;
            }

            // if is not visibility (setInterval emit time is 1s), use vbps to check
            if (isFalse(this.visibility)) {

                if (this._stats.vbps !== 0) {
                    this.debug && this.debug.warn(this.TAG_NAME, `checkHeartTimeout$2 but page is not visibility and vbps is ${this._stats.vbps}`)
                    return;
                }

            }


            const historyFpsListString = this._historyFpsList.join(',');
            this.debug.warn(this.TAG_NAME, `checkHeartTimeout$2 and
                pause and emit delayTimeout event and
                current vbps is ${this._stats.vbps} and
                current fps is ${this._stats.fps} and
                history FpsList is ${historyFpsListString} and
                current visibility is ${this.visibility} and`)
            this.emit(EVENTS.timeout, EVENTS.delayTimeout);
            this.emit(EVENTS.delayTimeout);
        } else {
            this.debug.log(this.TAG_NAME, `checkHeartTimeout$2 playbackPause is ${this.playbackPause}, playing is ${this.playing}`);
        }
    }

    checkStatsInterval() {
        this._checkStatsInterval = setInterval(() => {
            this.updateStats();
        }, 1000)
    }

    // loading 等待时间
    checkLoadingTimeout() {
        this._checkLoadingTimeout = setTimeout(() => {
            // check again
            if (this.playing) {
                this.debug.warn(this.TAG_NAME, `checkLoadingTimeout but loading is ${this.loading} and playing is ${this.playing}`)
                return;
            }

            if (this.isDestroyed()) {
                this.debug && this.debug.warn(this.TAG_NAME, `checkLoadingTimeout but player is destroyed`)
                return;
            }

            this.debug.warn(this.TAG_NAME, `checkLoadingTimeout and pause and emit loadingTimeout event`)
            this.emit(EVENTS.timeout, EVENTS.loadingTimeout);
            this.emit(EVENTS.loadingTimeout);

        }, this._opt.loadingTimeout * 1000)
    }

    clearCheckLoadingTimeout() {
        if (this._checkLoadingTimeout) {
            this.debug.log(this.TAG_NAME, `clearCheckLoadingTimeout`);
            clearTimeout(this._checkLoadingTimeout);
            this._checkLoadingTimeout = null;
        }
    }

    clearStatsInterval() {
        if (this._checkStatsInterval) {
            clearInterval(this._checkStatsInterval);
            this._checkStatsInterval = null;
        }
    }

    handleRender() {
        if (this.isDestroyed()) {
            this.debug && this.debug.warn(this.TAG_NAME, `handleRender but player is destroyed`)
            return;
        }

        if (this.loading) {
            //
            this.clearCheckLoadingTimeout();
            //  first emit loading event
            this.loading = false;
            //  next emit start event
            this.emit(EVENTS.start);
        }
        if (!this.playing) {
            this.playing = true;
        }
    }


    //
    updateStats(options = {}) {

        if (!this._startBpsTime) {
            this._startBpsTime = now();
        }

        if (isNotEmpty(options.ts)) {
            const ts = parseInt(options.ts, 10);
            this._stats.ts = ts;
            if (this._playingStartTimestamp === null && ts > 0) {
                this._playingStartTimestamp = ts;
            }
        }
        if (isNotEmpty(options.dts)) {
            this._stats.dts = parseInt(options.dts, 10);
        }

        if (isNotEmpty(options.mseTs)) {
            this._stats.mseTs = options.mseTs;
        }

        if (isNotEmpty(options.buf)) {
            this._stats.buf = options.buf;
        }

        if (isNotEmpty(options.netBuf)) {
            this._stats.netBuf = options.netBuf;
        }

        if (isNotEmpty(options.currentPts)) {
            this._stats.currentPts = options.currentPts;
        }

        if (options.fps) {
            this._stats.fps += 1;
        }
        if (options.dfps) {
            this._stats.dfps += 1;
        }

        if (options.abps) {
            this._stats.abps += options.abps;
        }

        if (options.vbps) {
            this._stats.vbps += options.vbps;
        }
        if (options.workerStats) {
            this._tempWorkerStats = options.workerStats;
        }

        if (options.isDropping) {
            this._stats.isDropping = options.isDropping;
        }

        if (options.mseVideoBufferDelayTime) {
            //  s -> ms
            this._stats.mseVideoBufferDelayTime = parseInt(options.mseVideoBufferDelayTime * 1000, 10);
        }

        const _nowTime = now();
        const timestamp = _nowTime - this._startBpsTime;

        //  waiting one second
        if (timestamp < 1 * 1000) {
            return;
        }

        if (this._playingStartTimestamp !== null) {
            if (this._stats.fps > 0) {
                this._stats.pTs += 1
            }
        }

        let sourceBufferDelay = 0;
        let sourceBufferStore = 0;
        let decodeDiffTimes = 0;
        let decodePlaybackRate = 0;
        let msePendingBuffer = 0;

        // just for mse
        if (this._opt.useMSE && this.mseDecoder) {
            sourceBufferDelay = this.mseDecoder.checkSourceBufferDelay();
            sourceBufferDelay = parseInt(sourceBufferDelay * 1000, 10)
            sourceBufferStore = this.mseDecoder.checkSourceBufferStore();
            sourceBufferStore = sourceBufferStore.toFixed(2);
            decodeDiffTimes = this.mseDecoder.getDecodeDiffTimes();
            decodePlaybackRate = this.mseDecoder.getDecodePlaybackRate();
            msePendingBuffer = this.mseDecoder.getPendingSegmentsLength();
        }

        // just for wcs
        if (this._opt.useWCS && this.webcodecsDecoder) {
            decodeDiffTimes = this.webcodecsDecoder.getDecodeDiffTimes();
        }

        // just for hls.js
        if (this.isOldHls() && this.hlsDecoder) {
            sourceBufferDelay = this.hlsDecoder.checkHlsBufferedDelay();
            sourceBufferDelay = parseInt(sourceBufferDelay * 1000, 10)
        }
        let hlsDemuxBufferedLength = 0;
        let hlsDemuxAudioBufferedLength = 0;
        let hlsDemuxVideoBufferedLength = 0;
        // just for hls 265
        if (this.isUseHls265() && this.hlsDecoder) {
            sourceBufferDelay = this.hlsDecoder.checkHlsBufferedDelay();
            sourceBufferDelay = sourceBufferDelay.toFixed(2);// 这里就是ms的。
            hlsDemuxBufferedLength = this.hlsDecoder.getDemuxBufferedListLength();
            hlsDemuxVideoBufferedLength = this.hlsDecoder.getDemuxVideoBufferedListLength();
            hlsDemuxAudioBufferedLength = this.hlsDecoder.getDemuxAudioBufferedListLength();
        }

        // just for wasm
        let flvBufferByteLength = 0;
        let demuxBufferDelay = 0;
        let audioDemuxBufferDelay = 0;
        let isStreamTsMoreThanLocal = false;
        let pushLatestDelay = 0;

        if (this._opt.useWasm || this._opt.demuxUseWorker) {
            //wasm | demux
            if (this._tempWorkerStats) {
                demuxBufferDelay = this._tempWorkerStats.demuxBufferDelay;
                audioDemuxBufferDelay = this._tempWorkerStats.audioDemuxBufferDelay;
                flvBufferByteLength = this._tempWorkerStats.flvBufferByteLength;
                this._stats.netBuf = this._tempWorkerStats.netBuf;
                pushLatestDelay = this._tempWorkerStats.pushLatestDelay;
                isStreamTsMoreThanLocal = this._tempWorkerStats.isStreamTsMoreThanLocal;
                this._stats.buf = this._tempWorkerStats.latestDelay;
            }
        } else {
            // mse or wcs
            if (this.demux) {
                flvBufferByteLength = this.demux.getInputByteLength();
                pushLatestDelay = this.demux.getPushLatestDelay();
                isStreamTsMoreThanLocal = this.demux.getIsStreamTsMoreThanLocal();
                if (this.demux.bufferList) {
                    demuxBufferDelay = this.demux.bufferList.length;
                }
            }
        }
        // just for audio
        let audioBufferDelay = 0;
        let audioBufferDelayTs = 0;
        if (this.audio && this.audio.bufferList) {
            audioBufferDelay = this.audio.bufferList.length;
            audioBufferDelayTs = parseInt(audioBufferDelay * this.audio.oneBufferDuration, 10);
        }

        // just for playback
        let playbackVideoBufferDelay = 0;
        let playbackVideoWaitingBufferDelay = 0;
        let playbackAudioWaitingBufferDelay = 0;
        let playbackCacheDataDuration = 0;
        if (this.isPlayback()) {
            if (this.video) {
                if (this._opt.playbackConfig.isUseFpsRender) {
                    playbackVideoBufferDelay = (this.video.bufferList && this.video.bufferList.length) || 0
                }
                let fps = this.video.getStreamFps();
                const oneFrameTs = fps > 0 ? (1000 / fps) : 0; // ms
                const videoBufferDelayTs = oneFrameTs * playbackVideoBufferDelay;
                const demuxBufferDelayTs = oneFrameTs * demuxBufferDelay;
                playbackCacheDataDuration = parseInt(videoBufferDelayTs + demuxBufferDelayTs, 10);
            }
        }
        let delayTs = 0;
        //
        if (this.videoTimestamp > 0) {
            delayTs = this._stats.dts - this.videoTimestamp;
        }
        const totalDelayTs = delayTs + this._stats.netBuf;

        if (this.isOldHls()) {
            this._stats.fps = this.hlsDecoder.getFps();
        }

        if (this._stats.fps > this._stats.maxFps) {
            this._stats.maxFps = this._stats.fps;
        }

        let videoCurrentTime = this.getVideoCurrentTime();
        const prevVideoCurrentTime = this._stats.videoCurrentTime;
        let videoCurrentTimeDiff = -1;
        if (prevVideoCurrentTime && videoCurrentTime) {
            videoCurrentTimeDiff = (videoCurrentTime - prevVideoCurrentTime).toFixed(2);
            videoCurrentTime = videoCurrentTime.toFixed(2);
        }

        let audioSyncVideo = 0;
        if (this.audioTimestamp > 0) {
            audioSyncVideo = this.audioTimestamp - this.getRenderCurrentPts();
        }

        this._allStatsData = Object.assign(this._stats, {
            audioBuffer: audioBufferDelay,
            audioBufferDelayTs: audioBufferDelayTs,
            audioTs: this.audioTimestamp,
            latestAudioTs: this.latestAudioTimestamp,
            // playback
            playbackVideoBuffer: playbackVideoBufferDelay,
            playbackVideoWaitingBuffer: playbackVideoWaitingBufferDelay,
            playbackAudioWaitingBuffer: playbackAudioWaitingBufferDelay,
            playbackCacheDataDuration,

            demuxBuffer: demuxBufferDelay,
            pushLatestDelay: pushLatestDelay,
            audioDemuxBuffer: audioDemuxBufferDelay,
            flvBuffer: flvBufferByteLength,
            // mse
            mseDelay: sourceBufferDelay,
            mseStore: sourceBufferStore,
            mseDecodeDiffTimes: decodeDiffTimes,
            mseDecodePlaybackRate: decodePlaybackRate,
            msePendingBuffer,
            // wcs
            wcsDecodeDiffTimes: decodeDiffTimes,
            // hls
            hlsDelay: sourceBufferDelay,
            hlsDemuxLength: hlsDemuxBufferedLength,
            hlsDemuxAudioLength: hlsDemuxAudioBufferedLength,
            hlsDemuxVideoLength: hlsDemuxVideoBufferedLength,
            delayTs,
            totalDelayTs,
            isStreamTsMoreThanLocal,
            //  for video
            videoCurrentTime,
            videoCurrentTimeDiff,
            audioSyncVideo
        })
        let performance = null;
        let videoSmooth = null;
        let videoSmoothInfo = '';
        if (this.isPlayer() &&
            this._opt.hasVideo &&
            this.playing) {
            performance = fpsStatus(this._stats.fps, this._flvMetaDataFps);
            this._allStatsData.performance = performance;
            const checkResult = this.checkVideoSmooth(this._allStatsData);
            videoSmoothInfo = checkResult.reason;
            videoSmooth = checkResult.result;
            this._allStatsData.videoSmooth = videoSmooth;
        }

        this.emit(EVENTS.stats, this._allStatsData);

        // emit error
        if (this._allStatsData.flvBuffer > FLV_BUFFER_LARGE_SIZE) {
            this.emit(EVENTS_ERROR.flvDemuxBufferSizeTooLarge, this._allStatsData.flvBuffer);
        }

        //
        if (this._opt.hasVideo) {
            this.updateHistoryFpsList(this._stats.fps, this._stats.videoCurrentTimeDiff);
            if (isNotEmpty(performance)) {
                this.emit(EVENTS.performance, performance);
            }
            if (isNotEmpty(videoSmooth)) {
                this.emit(EVENTS.videoSmooth, videoSmooth, videoSmoothInfo);
            }
        } else {
            if (this._opt.hasAudio) {
                //  use abps to check
                this.updateHistoryFpsList(this._stats.abps, 0);
            }
        }

        this._stats.fps = 0;
        this._stats.dfps = 0;
        this._stats.abps = 0;
        this._stats.vbps = 0;
        this._stats.isDropping = false;
        this._startBpsTime = _nowTime;
    }

    resetStats() {
        this._startBpsTime = null;
        this._playingStartTimestamp = null;
        this._historyFpsList = [];
        this._historyVideoDiffList = [];
        this._stats = {
            buf: 0, //ms
            netBuf: 0,  //
            fps: 0, //
            maxFps: 0,//
            dfps: 0, //
            abps: 0, //
            vbps: 0, //
            ts: 0, //
            mseTs: 0,//
            currentPts: 0,//
            pTs: 0, //
            dts: 0,//
            mseVideoBufferDelayTime: 0, // ms
            isDropping: false,
        }
        this._allStatsData = {};
    }

    //  检查video的是否丝滑
    checkVideoSmooth(stats) {
        let result = true;
        let reason = '';
        const maxDelay = (this._opt.videoBuffer + this._opt.videoBufferDelay);

        if (this.isWebrtcH264() ||
            this.isOldHls()) {
            return {result, reason};
        }

        //  没有网速
        if (stats.vbps === 0 &&
            isFalse(this._opt.isHls)) {
            reason = 'vbpsIsZero';
            this.debug.log(this.TAG_NAME, `checkVideoSmooth  false because ${reason}`);
            result = false;
        }

        if (result) {
            //  丢帧
            if (stats.isDropping) {
                reason = 'isDroppingIsTrue'
                this.debug.log(this.TAG_NAME, `checkVideoSmooth false because ${reason}`);
                result = false;
            }
        }

        if (result) {
            //  visibility is true
            if (this.visibility) {
                if (this._historyFpsList.length >= this._opt.heartTimeout) {
                    const calcList = removeMaxAndMin(this._historyFpsList);
                    // 算出平均值
                    const avgFps = calcList.reduce((a, b) => a + b, 0) / calcList.length;
                    const choppyFps = (avgFps * 0.83)
                    if (stats.fps < choppyFps) {
                        reason = 'fpsIsLow';
                        this.debug.log(this.TAG_NAME, `checkVideoSmooth false because fps is ${stats.fps} < min fix is ${choppyFps} and avgFps is ${avgFps}`);
                        result = false;
                    }
                }
            }
        }

        if (result) {
            if (this.visibility &&
                this._opt.useMSE) {
                if ((stats.videoCurrentTimeDiff >= 1.5 ||
                        stats.videoCurrentTimeDiff <= 0.5) &&
                    stats.videoCurrentTimeDiff !== -1) {
                    reason = 'videoCurrentTimeDiffIsNotNormal';
                    this.debug.log(this.TAG_NAME, `checkVideoSmooth false because videoCurrentTimeDiff is ${stats.videoCurrentTimeDiff}`);
                    result = false;
                }
            }
        }

        return {result, reason};
    }

    enableWakeLock() {
        if (this._opt.keepScreenOn) {
            this.keepScreenOn && this.keepScreenOn.enable();
        }
    }

    releaseWakeLock() {
        if (this._opt.keepScreenOn) {
            this.keepScreenOn && this.keepScreenOn.disable();
        }
    }

    clearBufferDelay() {
        if (this._opt.useWasm) {
            if (this.decoderWorker) {
                this.decoderWorker.clearWorkBuffer(true);
            }
        } else {
            if (this.demux) {
                this.demux.clearBuffer(true);
            }
        }
    }

    doDestroy() {
        this.emit(EVENTS.beforeDestroy)
    }

    handlePlayToRenderTimes() {
        if (this.isClosed() || this.isDestroyed()) {
            this.debug.log(this.TAG_NAME, `handlePlayToRenderTimes but player is closed or destroyed`);
            return;
        }
        const _times = this.getPlayToRenderTimes();
        this.emit(EVENTS.playToRenderTimes, _times);
    }

    getPlayToRenderTimes() {
        const _times = this._times;
        // play init time
        _times.playTimestamp = _times.playStart - _times.playInitStart;
        // stream start time
        _times.streamTimestamp = _times.streamStart - _times.playStart;
        // stream response time
        _times.streamResponseTimestamp = _times.streamResponse - _times.streamStart > 0 ? _times.streamResponse - _times.streamStart : 0;
        // demux time
        _times.demuxTimestamp = _times.demuxStart - _times.streamResponse > 0 ? _times.demuxStart - _times.streamResponse : 0;
        // decode times
        _times.decodeTimestamp = _times.decodeStart - _times.demuxStart > 0 ? _times.decodeStart - _times.demuxStart : 0;
        // start render time
        _times.videoTimestamp = _times.videoStart - _times.decodeStart;
        // all time
        _times.allTimestamp = _times.videoStart - _times.playInitStart;
        return _times;
    }

    getOption() {
        return this._opt;
    }

    getPlayType() {
        return this._opt.playType;
    }

    isPlayer() {
        return this._opt.playType === PLAY_TYPE.player
    }

    isPlayback() {
        return this._opt.playType === PLAY_TYPE.playbackTF;
    }

    isDemuxSetCodecInit() {
        let result = true;
        let _opt = this._opt;
        if (_opt.useWCS && !_opt.useOffscreen) {
            if (this.webcodecsDecoder) {
                result = this.webcodecsDecoder.hasInit;
            } else {
                result = false;
            }
        } else if (_opt.useMSE) {
            if (this.mseDecoder) {
                result = this.mseDecoder.hasInit;
            } else {
                result = false;
            }
        }

        return result;
    }

    isDemuxDecodeFirstIIframeInit() {
        let result = true;
        let _opt = this._opt;
        if (_opt.useWCS && !_opt.useOffscreen) {
            if (this.webcodecsDecoder) {
                result = this.webcodecsDecoder.isDecodeFirstIIframe;
            } else {
                result = false;
            }
        } else if (_opt.useMSE) {
            if (this.mseDecoder) {
                result = this.mseDecoder.isDecodeFirstIIframe;
            } else {
                result = false;
            }
        }

        return result;
    }

    isAudioPlaybackRateSpeed() {
        let result = false;
        if (this.audio) {
            result = this.audio.isPlaybackRateSpeed();
        }
        return result;
    }


    getPlayingTimestamp() {
        return this._stats.pTs;
    }

    getRecordingType() {
        let result = null;

        if (this.recorder) {
            result = this.recorder.getType();
        }
        return result;
    }

    getRecordingByteLength() {
        let result = 0;
        if (this.recording) {
            result = this.recorder.getToTalByteLength();
        }
        return result;
    }

    getRecordingDuration() {
        let result = 0;
        if (this.recording) {
            result = this.recorder.getTotalDuration();
        }
        return result;
    }

    getDecodeType() {
        let result = '';
        const options = this.getOption();

        if (this.isWebrtcH264()) {
            return DECODE_TYPE.webrtc;
        }

        if (this.isAliyunRtc()) {
            return DECODE_TYPE.aliyunRtc;
        }

        if (this.isOldHls()) {
            return DECODE_TYPE.hls;
        }

        if (options.useMSE) {
            result += DECODE_TYPE.mse + ' '
        }
        if (options.useWCS) {
            result += DECODE_TYPE.wcs + ' '
        }
        if (options.useWasm) {
            result += DECODE_TYPE.wasm + ' '

            if (options.useSIMD) {
                result += DECODE_TYPE.simd + ' '
            }

            if (options.useMThreading) {
                result += DECODE_TYPE.mt + ' '
            }
        }

        if (options.useOffscreen) {
            result += DECODE_TYPE.offscreen + ' '
        }

        return result;
    }

    getDemuxType() {
        let result = '';
        const options = this.getOption();
        result = options.demuxType;
        return result;
    }


    getRenderType() {
        let result = '';
        if (this.video) {
            result = this.video.getType();
        }

        return result;
    }

    getCanvasRenderType() {
        let result = '';
        if (this.video) {
            result = this.video.getCanvasType();
        }

        return result;
    }

    getAudioEngineType() {
        let result = '';
        if (this.audio) {
            result = this.audio.getEngineType();
        }
        return result;
    }

    getStreamType() {
        let result = '';
        if (this.stream) {
            result = this.stream.getStreamType();
        }
        return result;
    }

    getAllStatsData() {
        return this._allStatsData;
    }

    togglePerformancePanel(toggle) {
        this.updateOption({
            showPerformance: toggle
        })
        this.emit(EVENTS.togglePerformancePanel, toggle)
    }


    setScaleMode(type) {
        type = Number(type);
        let options = {
            isFullResize: false,
            isResize: false,
            aspectRatio: 'default'
        }
        switch (type) {
            case SCALE_MODE_TYPE.full:
                options.isFullResize = false;
                options.isResize = false;
                break;
            case SCALE_MODE_TYPE.auto:
                options.isFullResize = false;
                options.isResize = true;
                break;
            case SCALE_MODE_TYPE.fullAuto:
                options.isFullResize = true;
                options.isResize = true;
                break;
        }
        this.updateOption(options);
        this.resize();
        this.emit(EVENTS.viewResizeChange, type)
    }

    startVisibilityHiddenTimeout() {
        this.clearVisibilityHiddenTimeout();
        //
        if (this._opt.pageVisibilityHiddenTimeout > 0) {
            this.visibilityHiddenTimeout = setTimeout(() => {
                this.emit(EVENTS.visibilityHiddenTimeout);
            }, this._opt.pageVisibilityHiddenTimeout * 1000);
        }
    }

    clearVisibilityHiddenTimeout() {
        if (this._checkVisibleHiddenTimeout) {
            clearTimeout(this._checkVisibleHiddenTimeout);
            this._checkVisibleHiddenTimeout = null;
        }
    }

    faceDetect(toggle) {
        this.faceDetectActive = toggle;
    }

    objectDetect(toggle) {
        this.objectDetectActive = toggle;
    }

    occlusionDetect(toggle) {
        this.occlusionDetectActive = toggle;
    }

    // todo：供测试使用
    downloadNakedFlowFile() {
        if (this.demux && this.demux.downloadNakedFlowFile) {
            this.demux.downloadNakedFlowFile();
        }
    }

    //  todo:供测试使用
    downloadFmp4File() {
        if (this.demux && this.demux.downloadFmp4File) {
            this.demux.downloadFmp4File();
        }
    }

    //  todo:供测试使用
    downloadMpeg4File() {
        const blob = new Blob([this._tempStreamList]);
        try {
            const oa = document.createElement('a');
            oa.href = window.URL.createObjectURL(blob);
            oa.download = Date.now() + '.mpeg4';
            oa.click();
            window.URL.revokeObjectURL(oa.href);
        } catch (e) {
            console.error('downloadMpeg4File', e);
        }
    }

    hasCacheOnGopBuffer() {
        const gopTimestamp = this.videoIframeIntervalTs;
        const delayBufferLength = this._allStatsData.demuxBuffer;
        const fps = this._allStatsData.maxFps;
        let result = false;
        if (gopTimestamp && delayBufferLength && fps) {
            const allTimestamp = (1000 / fps) * delayBufferLength;
            result = allTimestamp > gopTimestamp;
        }
        return result;
    }

    addContentToCanvas(contentList = []) {
        if (this.video) {
            this.video.addContentToCanvas(contentList);
        }
    }

    sendWebsocketMessage(msg) {
        const streamType = this.getStreamType();
        if (streamType === PLAYER_STREAM_TYPE.websocket ||
            streamType === (PLAYER_STREAM_TYPE.worker + " " + PLAYER_STREAM_TYPE.websocket)) {
            this.stream.sendMessage(msg);
        } else {
            this.debug.warn(this.TAG_NAME, `sendWebsocketMessage: stream type is not websocket, current stream type is ${this.getStreamType()}`)
        }
    }

    checkIsInRender() {
        const _stats = this._stats;
        //
        return _stats.vbps > 0 && _stats.fps > 0;
    }

    setControlHtml(html) {
        if (this.control && this.control.$controlHtml) {
            this.control.$controlHtml.innerHTML = html;
        }
    }

    clearControlHtml() {
        if (this.control && this.control.$controlHtml) {
            this.control.$controlHtml.innerHTML = '';
        }
    }

    updateWatermark(config) {
        if (this.singleWatermark) {
            this.singleWatermark.update(config);
        }
    }

    removeWatermark() {
        if (this.singleWatermark) {
            this.singleWatermark.remove();
        }
    }


    getVideoInfo() {
        let result = null;
        if (this.video) {
            result = this.video.getVideoInfo();
        }
        return result;
    }

    getAudioInfo() {
        let result = null;
        if (this.audio) {
            result = this.audio.getAudioInfo();
        }
        return result;
    }


    getVideoPlaybackQuality() {
        let result = null;
        if (this.video) {
            result = this.video.getPlaybackQuality();
        }
        return result;
    }

    emitError(errorType, message = '') {
        this.emit(EVENTS.error, errorType, message);
        this.emit(errorType, message);
    }

    updateHistoryFpsList(fps, videoDiff) {
        if (this.playbackPause) {
            return
        }

        if (this._historyFpsList.length > this._opt.heartTimeout) {
            this._historyFpsList.shift();
            this._historyVideoDiffList.shift();
        }
        this._historyFpsList.push(fps);
        this._historyVideoDiffList.push(videoDiff);

        if (this.isHistoryFpsListAllZero()) {
            this.checkHeartTimeout$2();
        }
    }

    isHistoryFpsListAllZero() {
        let result = true;

        if (this._historyFpsList.length < this._opt.heartTimeout) {
            result = false;
        }

        if (result) {
            for (let i = 0; i < this._historyFpsList.length; i++) {
                if (this._historyFpsList[i] > 0) {
                    result = false;
                    break;
                }
            }
        }

        if (result) {
            for (let i = 0; i < this._historyVideoDiffList.length; i++) {
                if (this._historyVideoDiffList[i] > 0) {
                    result = false;
                    break;
                }
            }
        }

        return result;
    }

    isUseHls265() {
        return isTrue(this._opt.isHls) && isTrue(this._opt.supportHls265);
    }

    isOldHls() {
        return isTrue(this._opt.isHls) && isFalse(this._opt.supportHls265);
    }

    isWebrtcNotH265() {
        return isTrue(this._opt.isWebrtc) && isFalse(this._opt.isWebrtcH265);
    }

    isWebrtcH264() {
        return isTrue(this._opt.isWebrtc) && isFalse(this._opt.isWebrtcH265);
    }

    isWebrtcH265() {
        return isTrue(this._opt.isWebrtc) && isTrue(this._opt.isWebrtcH265);
    }

    isAliyunRtc() {
        return isTrue(this._opt.isAliyunRtc);
    }

    isStreamWebTransport() {
        return this.getStreamType() === PLAYER_STREAM_TYPE.webTransport;
    }

    //
    isPlaybackCacheBeforeDecodeForFpsRender() {
        return this.isPlayback()
            && isTrue(this._opt.playbackConfig.isCacheBeforeDecodeForFpsRender)
            && isTrue(this._opt.useWCS);
    }

    isPlaybackUseWCS() {
        return this.isPlayback() && isTrue(this._opt.useWCS);
    }

    isPlaybackUseMSE() {
        return this.isPlayback() && isTrue(this._opt.useMSE);
    }

    isPlayUseMSE() {
        return this.isPlayer() && isTrue(this._opt.useMSE);
    }

    isInWebFullscreen() {
        return this._opt.useWebFullScreen &&
            isMobile() &&
            this.fullscreen;
    }

    getPlaybackRate() {
        let result = 1;
        if (isTrue(this.isPlayback()) && this.playback) {
            result = this.playback.rate;
        }
        return result;
    }

    isPlaybackOnlyDecodeIFrame() {
        return isTrue(this.isPlayback()) && this.getPlaybackRate() >= this._opt.playbackForwardMaxRateDecodeIFrame;
    }

    pushTempStream(stream) {
        const arrayBuffer = new Uint8Array(stream);
        this._tempStreamList.push(arrayBuffer);
    }

    updateLoadingText(text) {
        if (this.loading && this.control) {
            this.control.updateLoadingText(text);
        }
    }

    //  for video element
    getVideoCurrentTime() {
        let currentTime = 0;
        if (this.video) {
            if (this._opt.useMSE &&
                this.mseDecoder) {
                currentTime = this.mseDecoder.getVideoCurrentTime();
            } else if (this.isWebrtcH264() && this.webrtc) {
                currentTime = this.webrtc.getVideoCurrentTime();
            } else if (this.isAliyunRtc() && this.aliyunRtcDecoder) {
                currentTime = this.aliyunRtcDecoder.getVideoCurrentTime();
            }
        }
        return currentTime;
    }

    addMemoryLog(tag, ...args) {
        this.emit(EVENTS.memoryLog, ` [${tag}] `, ...args);
    }


    downloadMemoryLog() {
        this.emit(EVENTS.downloadMemoryLog);
    }

    //  is in multi
    isInMulti() {
        return this._opt.multiIndex !== -1;
    }

    //
    isWebrtcForM7S() {
        return isFalse(this._opt.isWebrtcForZLM) &&
            isFalse(this._opt.isWebrtcForSRS) &&
            isFalse(this._opt.isWebrtcForOthers)
    }


    updateMetaData(metaData) {
        this.debug.log(this.TAG_NAME, 'updateMetaData', JSON.stringify(metaData));
        this._flvMetaData = metaData;

        if (this._flvMetaData) {
            const metaData = this._flvMetaData;

            if (isNumber(metaData.framerate)) {
                const fpsNum = Math.floor(metaData.framerate * 1000);
                if (fpsNum > 0) {
                    const fps = fpsNum / 1000;
                    this._flvMetaDataFps = fps;
                }
            }

            if (isBoolean(metaData.hasAudio) &&
                isFalse(metaData.hasAudio)) {
                this.debug.log('updateMetaData', 'hasAudio', metaData.hasAudio, 'and update _opt.hasAudio');
                this._opt.hasAudio = metaData.hasAudio;
            }

            if (isBoolean(metaData.hasVideo) &&
                isFalse(metaData.hasVideo)) {
                this.debug.log('updateMetaData', 'hasVideo', metaData.hasVideo, 'and update _opt.hasVideo');
                this._opt.hasVideo = metaData.hasVideo;
            }
        }


        this.emit(EVENTS.flvMetaData, metaData);
    }

    getMetaData() {
        return this._flvMetaData;
    }

    getExtendBtnList() {
        const extendBtnList = this.control.getExtendBtnList();
        return extendBtnList.map((item) => {
            return {
                name: item.name,
                $container: item.$iconContainer,
                $btn: item.$iconWrap,
                $activeBtn: item.$activeIconWrap
            }
        })
    }

    getCpuLevel() {
        let result = null;
        if (this.pressureObserverCpu) {
            result = this.pressureObserverCpu.getCurrentCpuState();
        }
        return result;
    }

    isRecordTypeFlv() {
        return this.recorder && this._opt.recordType === FILE_SUFFIX.flv;
    }

    isRecordTypeMp4() {
        return this.recorder && this._opt.recordType === FILE_SUFFIX.mp4;
    }

    isRecordTypeWebm() {
        return this.recorder && this._opt.recordType === FILE_SUFFIX.webm;
    }

    isDemuxInWorker() {
        return this._opt.useWasm || this._opt.demuxUseWorker;
    }

    isUseMSE() {
        return isTrue(this._opt.useMSE);
    }

    isUseWCS() {
        return isTrue(this._opt.useWCS);
    }

    isUseWASM() {
        return isTrue(this._opt.useWasm);
    }

    getAudioSyncVideoDiff() {
        let result = this.audioTimestamp - this.getRenderCurrentPts();
        return result;
    }

    getMseVideoBufferDelayTime() {
        let result = 0;
        if (this._opt.useMSE &&
            this.mseDecoder) {
            //  s
            result = this.mseDecoder.getVideoBufferDelayTime();
            // s -> ms
            result = parseInt(result * 1000, 10);
        }

        return result;
    }

    updateCurrentPts(pts) {
        this.updateStats({
            currentPts: pts
        })
        this.emit(EVENTS.currentPts, pts);
    }

    //  获取到渲染的最新pts
    getRenderCurrentPts() {
        let result = 0;
        if (this._stats.currentPts) {
            result = this._stats.currentPts;
        } else {
            result = this.videoTimestamp - this.getMseVideoBufferDelayTime();
        }

        return result;
    }

    openSyncAudioAndVideo() {
        return this._opt.syncAudioAndVideo && this._opt.hasVideo;
    }

    showTipsMessageByCode(code) {
        if (this.control) {
            const message = this._opt.showMessageConfig[code] || '未知异常';
            this.control.showTipsMessage(message, code);
        }
    }

    showTipsMessageByContent(content) {
        if (this.control && content) {
            this.control.showTipsMessage(content);
        }
    }

    hideTipsMessage() {
        if (this.control) {
            this.control.hideTipsMessage();
        }
    }

    decoderCheckFirstIFrame() {
        if (isTrue(this._opt.checkFirstIFrame)) {
            if (this.mseDecoder) {
                this.mseDecoder.isDecodeFirstIIframe = false;
            } else if (this.webcodecsDecoder) {
                this.webcodecsDecoder.isDecodeFirstIIframe = false;
            }
        }
    }

    isHlsCanVideoPlay() {
        return this._canPlayAppleMpegurl && this.isOldHls()
    }
}
